<script>
import { VCheckbox } from 'vuetify/lib';
export default VCheckbox;
</script>
